import LocalizedCookieBanner from './LocalizedCookieBanner';
import LocalizedCookieBannerContainer from './LocalizedCookieBanner.container';
export default LocalizedCookieBannerContainer(LocalizedCookieBanner);
